var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa-marketing-web-client@3.37.9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["aa-mkt-web-client@age-of-learning"]={id:"aa-marketing-web-client@3.37.9"};
      